var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"header"},[_c('strong',[_vm._v(_vm._s(_vm.$t("helpers.chat.user_support")))]),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.closeModal}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }